export default [
    {
        key: 'blend',
        icon: require('../../../assets/images/home_icon_download@2x.png'),
        name: '扫码下载',
        image: ''
    },
    {
        key: 'weixin',
        icon: require('../../../assets/images/home_icon_wechat@2x.png'),
        name: '微信二维码',
        image: ''
    },
    {
        key: 'weibo',
        icon: require('../../../assets/images/home_icon_weibo@2x.png'),
        name: '微博二维码',
        image: ''
    }
]
